import graphql from "babel-plugin-relay/macro";
import { Provider } from "jotai";
import { useFragment } from "react-relay";

import { StandardModal } from "@whoosh/design-system/src/components/overlay/StandardModal";

import { CancelBookingModal_Booking$key } from "./__generated__/CancelBookingModal_Booking.graphql";
import { ModalStepOutlet } from "./components/ModalStepOutlet/ModalStepOutlet";
import { useInitializeCancelBookingModal } from "./hooks/useInitializeCancelBookingModal";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  bookingRef: CancelBookingModal_Booking$key;
  currentSessionUserClientId: string;
};

export const CancelBookingModal = ({
  isOpen,
  onClose,
  bookingRef,
  currentSessionUserClientId,
}: Props) => {
  return (
    <StandardModal
      isOpen={isOpen}
      onClose={() => {}}
      hideCloseButton={true}
      disableContentScroll={true}
      content={
        isOpen ? (
          <Provider>
            <CancelBookingModalContent
              onClose={onClose}
              bookingRef={bookingRef}
              currentSessionUserClientId={currentSessionUserClientId}
            />
          </Provider>
        ) : undefined
      }
    />
  );
};

type EditBookingModalContentProps = {
  onClose: () => void;
  bookingRef: CancelBookingModal_Booking$key;
  currentSessionUserClientId: string;
};

const CancelBookingModalContent = ({
  onClose,
  bookingRef,
  currentSessionUserClientId,
}: EditBookingModalContentProps) => {
  const booking = useFragment(CancelBookingModalFragmentString, bookingRef);
  useInitializeCancelBookingModal({
    bookingRef: booking,
  });

  return (
    <ModalStepOutlet
      bookingRef={booking}
      onClose={onClose}
      currentUserClientId={currentSessionUserClientId}
    />
  );
};

const CancelBookingModalFragmentString = graphql`
  fragment CancelBookingModal_Booking on Booking {
    ...ModalStepOutlet_CancelBooking_Booking
    ...useInitializeCancelBookingModal_Booking
  }
`;
